import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "slide"]
  static values = {
    interval: { type: Number, default: 5000 }
  }

  connect() {
    this.currentIndex = 0
    this.showCurrent({ animateWidth: false })
    this.resume()
    this.handleResize = this.handleResize.bind(this)
    window.addEventListener("resize", this.handleResize)
  }

  disconnect() {
    this.pause()
    window.removeEventListener("resize", this.handleResize)
    this.cancelWidthUpdate()
  }

  next() {
    this.currentIndex =
      (this.currentIndex + 1) % this.slideTargets.length

    this.showCurrent()
    this.resume()
  }

  previous() {
    this.currentIndex =
      (this.currentIndex - 1 + this.slideTargets.length) %
      this.slideTargets.length

    this.showCurrent()
    this.resume()
  }

  pause() {
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }

  resume() {
    this.pause()

    if (this.slideTargets.length <= 1) {
      return
    }

    this.timer = setInterval(() => {
      this.next()
    }, this.intervalValue)
  }

  showCurrent({ animateWidth = true } = {}) {
    this.slideTargets.forEach((slide, index) => {
      const isCurrent = index === this.currentIndex

      if (isCurrent) {
        slide.style.removeProperty("transition-duration")
      } else {
        slide.style.transitionDuration = "0ms"
      }

      slide.classList.toggle("relative", isCurrent)
      slide.classList.toggle("absolute", !isCurrent)
      // slide.classList.toggle("left-0", !isCurrent)
      // slide.classList.toggle("top-0", !isCurrent)
      slide.classList.toggle("opacity-100", isCurrent)
      slide.classList.toggle("opacity-0", !isCurrent)
      slide.classList.toggle("pointer-events-auto", isCurrent)
      slide.classList.toggle("pointer-events-none", !isCurrent)
      slide.setAttribute("aria-hidden", String(!isCurrent))
    })

    this.updateTrackWidth({ animate: animateWidth })
  }

  handleResize() {
    this.updateTrackWidth({ animate: false })
  }

  cancelWidthUpdate() {
    window.cancelAnimationFrame(this.widthAnimationFrame)
    this.measuringSlide?.style.removeProperty("max-width")
    this.measuringSlide = null
    if (this.hasTrackTarget) {
      this.trackTarget.style.removeProperty("transition-duration")
    }
  }

  updateTrackWidth({ animate }) {
    if (!this.hasTrackTarget) return

    this.cancelWidthUpdate()
    this.widthAnimationFrame = window.requestAnimationFrame(() => {
      // Let the mobile layout size naturally within the available space.
      if (!window.matchMedia("(min-width: 768px)").matches) {
        this.trackTarget.style.removeProperty("width")
        return
      }

      const currentSlide = this.slideTargets[this.currentIndex]
      if (!currentSlide) return

      // Allow a layout pass before reading the unconstrained text width.
      // The track clips overflow while the slide is temporarily unconstrained.
      this.measuringSlide = currentSlide
      currentSlide.style.maxWidth = "none"
      this.widthAnimationFrame = window.requestAnimationFrame(() => {
        const width = Math.ceil(currentSlide.getBoundingClientRect().width)
        currentSlide.style.removeProperty("max-width")
        this.measuringSlide = null
        if (!width) return

        if (!animate) this.trackTarget.style.transitionDuration = "0ms"
        this.trackTarget.style.width = `${width}px`

        if (!animate) {
          // Let the width paint before re-enabling transitions, without forcing layout.
          this.widthAnimationFrame = window.requestAnimationFrame(() => {
            this.trackTarget.style.removeProperty("transition-duration")
          })
        }
      })
    })
  }
}
